import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessNotes, IBusinessView, INotesViewModel } from "app/models/business/business";

import { BusinessService } from "app/services/business/business.service";


@Component({
  selector: 'businessCommentsModal',
  styleUrls: ['./businessCommentsModal.component.scss'],
  templateUrl: './businessCommentsModal.component.html'
})

export class BusinessCommentsModalComponent implements OnInit {

  currentBusiness: IBusinessView = {} as IBusinessView;
  notes: INotesViewModel[] = [];
  businessId: number = 0;
  savedBusiness: boolean = false;

  newNote: INotesViewModel = {
    id: 0,
    loggedDate: '',
    type: 'business view',
    text: '',
    user: ''
  };


  form = new UntypedFormGroup({
    businessComments: new UntypedFormControl('')
  });

  constructor(
    private sharedService: SharedService,
    private businessService: BusinessService,
    private dialogRef: MatDialogRef<BusinessCommentsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.businessId = this.data.businessId;
  }

  ngOnInit(): void {
    this.savedBusiness = false;
  }

  save() {
    if (this.form.controls['businessComments'].value != null && this.form.controls['businessComments'].value != '') {

      this.newNote.text = this.form.controls['businessComments'].value;
      this.notes.push(this.newNote);
      this.businessService.addBusinessNote(this.businessId, this.notes).subscribe({
        next: response => {
          this.sharedService.toastr.success("Business Info Saved");
          this.savedBusiness = true;
          this.return();
        },
        error: e => {
          this.sharedService.toastr.error("Could not add Business Note Info");
        },
      });

    }
  }

  return(): void {
    let returnData = this.savedBusiness ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }

}